import Component from '@glimmer/component';

export default class DisplayOrElseComponent extends Component {
  <template>
    {{#if @value}}
      {{~@value~}}
    {{else}}
      {{~yield~}}
    {{/if~}}
  </template>
}
